const { createContext } = require("react");

const DataContext = createContext();

export default DataContext;